import request from "../../components/request";
import {
  decimalPlaces,
  integerValidation,
  inputValidate,
} from "./tools";

let resetSexRadio = false;
let resetUnitRadio = false;

decimalPlaces("creatinine1");
integerValidation("creatinine1");
decimalPlaces("creatinine2");
integerValidation("creatinine2");

$("input[type=radio][name=sex]").on("change", function () {
  if (resetSexRadio) {
    resetSexRadio = false;
    resetUnitRadio = false;
  }
  resetSexRadio = true;
});

$("input[type=radio][name=unit]").on("change", function () {
  $("#unit").html($(this).val());
  $(".creatinine").removeClass("d-block").addClass("d-none");
  $(`.creatinine[data-id="${$(this).val()}"]`)
    .removeClass("d-none")
    .addClass("d-block");
  if (resetUnitRadio) {
    resetUnitRadio = false;
    resetSexRadio = false;
  }
  resetUnitRadio = true;
});

$("#calculate-ckd-epi").on("click", function () {
  const sex = $('input[name="sex"]:checked').val();
  const age = $("#ckd-epi-age").val();
  const unit = $('input[name="unit"]:checked').val();
  const creatinine1 = $("#creatinine1").val().replace(",", ".");
  const creatinine2 = $("#creatinine2").val().replace(",", ".");

  const validCreatinine =
    unit == "mg/dL"
      ? inputValidate(creatinine1, 0.0, 5.0, "creatinine1")
      : inputValidate(creatinine2, 0.0, 300.0, "creatinine2");

  const creatinine = unit == "mg/dL" ? creatinine1 : creatinine2;

  if (sex !== undefined && age !== "" && validCreatinine) {
    $("#ckd-epi-error")
      .html("Uzupełnij wszystkie pola")
      .removeClass("d-block")
      .addClass("d-none");

    $("#wrapper-ckd-epi").removeClass("d-none");
    $("#loader-ckd-epi").removeClass("d-none").addClass("d-flex");
    $("#data-ckd-epi").addClass("d-none");
    asyncGetDataCKDEpi(sex, age, creatinine, unit);
  } else {
    $("#ckd-epi-error")
      .html("Uzupełnij wszystkie pola")
      .removeClass("d-none")
      .addClass("d-block");
  }
});

async function asyncGetDataCKDEpi(sex, age, creatinine, unit) {
  const egfr = await request("calculator", "ckd-epi", {
    sex: sex,
    age: age,
    creatinine: creatinine,
    unit: unit,
  });
  setDataCKDEpi(egfr);
}

function setDataCKDEpi(egfr) {
  if (egfr.status) {
    $("#ckd-epi-egfr").html(
      Number.parseFloat(egfr.eGFR).toFixed(1).replace(".", ",")
    );
    $("#data-ckd-epi").removeClass("d-none").fadeIn(300);
  } else {
    $("#ckd-epi-error")
      .html("Sprawdź czy podane wartości są prawidłowe.")
      .removeClass("d-none")
      .addClass("d-block");
  }
  $("#loader-ckd-epi").removeClass("d-flex").addClass("d-none");
}
